<div class="confirm-modal ig-modal trip-detail-modal" [ngStyle]="{'paddingTop':data.type==='place'?'24px':'0'}">
    <div *ngIf="data.type==='event'"
         style="text-align: center;font-size: 16px;color: white;background-color: #383990;height: 26px;line-height: 26px;margin-bottom: 24px">
        <div *ngIf="userSelectedToViewFeed" id="back-to-info" (click)="back()">Back to the {{ data.type }} info</div>
        <div *ngIf="!userSelectedToViewFeed" id="back-to-all" (click)="close()">Back to all {{ data.type + 's' }}</div>
    </div>
    <div *ngIf="data.type==='place'" class="close-button" (click)="userSelectedToViewFeed?back():close()">
        <span><&nbsp;&nbsp; Take me back</span>
        <!--        <mat-icon *ngIf="!userSelectedToViewFeed">clear</mat-icon>-->
        <!--        <mat-icon *ngIf="userSelectedToViewFeed">chevron_left</mat-icon>-->
    </div>

    <div class="info-wrap" *ngIf="!userSelectedToViewFeed">
        <div style="padding:0 24px">
            <!--            <ig-image #imgComp *ngIf="data.item.socialName!=='google'" class="detail-image"-->
            <!--                      [imageUrl]="data.item.cover?.source"></ig-image>-->
            <ig-image-viewer #imgViewer *ngIf="placePhotos.length"
                             [images]="placePhotos"
                             [alt]="data.item.title||data.item.name"
                             [showingCount]=placeImagesShownCount></ig-image-viewer>
            <div *ngIf="data.item.socialName==='google'&&!googleInfo" class="google-img-loading">
                <div>Loading...</div>
            </div>
            <div class="detail-title">{{ data.item.name }}</div>
        </div>

        <div *ngIf="data.type==='place'" class="flex float-detail-btn-wrap" style="padding:0 24px">
            <ig-fb-login-btn class="invisible" #loginWithFBBtn
                             (onLoginStatusChanged)="$event && getFacebookPlaceFeed()"></ig-fb-login-btn>

            <div add *ngIf="data.isShowAddToTripBtn">
                <ig-add-to-trip-menu [hubName]="hubName" [item]="data.item"></ig-add-to-trip-menu>
            </div>
            <div post *ngIf="isShowViewFBPostBtn&&!isFacebookLoggedIn&&data.item.socialName==='facebook'"
                 (click)="loginWithFBBtn.login()" role="button">
                view <span class="show-below-370">FB</span><span class="hide-on-below-370">facebook</span> posts
                <!--                <ig-fb-login-btn class="invisible" #loginWithFBBtn-->
                <!--                                 (onLoginStatusChanged)="$event && getFacebookPlaceFeed()"></ig-fb-login-btn>-->
            </div>
            <div post *ngIf="(isShowViewFBPostBtn&&isFacebookLoggedIn&&data.item.socialName==='facebook')"
                 (click)="getFacebookPlaceFeed()" role="button">
                view facebook posts
            </div>
            <div post *ngIf="data.item.socialName==='google'&&featuresToggle?.googleReviews&&isGoogleFeedLoaded"
                 class="posts-reviews-wrap">
                <!--                <ig-button *ngIf="featuresToggle?.facebookPosts" (trigger)="viewFBPost()" class="facebook-btn">-->
                <!--                    <img class="facebook-logo" [src]="fbLogo" alt="facebook logo">-->
                <!--                    Facebook Posts-->
                <!--                </ig-button>-->
                <ig-button *ngIf="featuresToggle?.nearbyPlacesRight&&!data.isShowAddToTripBtn"
                           (trigger)="showPlaceFeed('nearby')" class="nearby-places-btn">
                    <mat-icon>room</mat-icon>
                    Nearby Places
                </ig-button>
                <ig-button (trigger)="showPlaceFeed('google')" class="google-btn"
                           [class.only-google-btn]="!featuresToggle?.facebookPosts">
                    <span logo>G</span>
                    Google Reviews
                </ig-button>
            </div>
        </div>

        <ng-container *ngIf="data.type==='event'&&data.item&&data.item.name">
            <div style="padding: 0 24px" class="add-to-trip-wrap">
                <ig-add-to-trip-menu *ngIf="data.isShowAddToTripBtn" [hubName]="hubName"
                                     [item]="data.item"></ig-add-to-trip-menu>
            </div>

            <div style="padding:0 24px">
                <p class="dates-times-title">Dates & Times</p>
                <div class="dates-times">
                    <div>
                        <div *ngFor="let time of data.item.eventTimes" class="times-box">
                            <!--                            {{time.startTimeFormatted}}-->
                            <p>{{ time['noTimeFormatted'] }}</p>
                            <p style="font-size: 13px">{{ time['timeFormatted'] }}</p>
                        </div>
                    </div>
                </div>

                <div description *ngIf="data.type==='event'"
                     [innerHTML]="data.item.description||'(No Description)'"></div>
            </div>

            <div class="m-t-3 info-tickets">
                <p>Information and Tickets</p>
                <div *ngIf="normalTicketUri" class="flex space-between">
                    <div class="e-venue">{{ processedTicketUri }}</div>
                    <ig-button size="md" (trigger)="openTicketUrl(data.item.ticketUri)">Tickets</ig-button>
                </div>
                <div *ngIf="data.item.ticketInfo?.length>1">
                    <div *ngFor="let e of data.item.ticketInfo" class="flex space-between m-t-3">
                        <div style="line-height: 32px" class="e-venue">{{ e.source.replace('www.', '') }}</div>
                        <ig-button size="md" (trigger)="openTicketUrl(e.link)">Tickets</ig-button>
                    </div>
                </div>
                <div class="flex space-between m-t-3">
                    <div style="line-height: 32px" class="e-venue">{{ data.item.owner?.name }}</div>
                    <ig-button size="md" color="cancel" (trigger)="visitWebsite()">More info</ig-button>
                </div>
            </div>

            <div class="m-t-3 venue-location">
                <p title>Venue & Location</p>

                <a *ngIf="data.item.hostLink&&venueName" class="e-venue" [href]="getLink(data.item.hostLink)"
                   target="_blank" [matTooltip]="venueName">{{ venueName }}</a>
                <div *ngIf="!data.item.hostLink&&venueName" class="e-venue" [matTooltip]="venueName">{{ venueName }}
                </div>
                <div class="e-address" [matTooltip]="data.item.address?.address">{{ data.item.address?.address }}</div>
                <div *ngIf="data.item.venueInfo?.rating" class="flex">
                    <p>{{ data.item.venueInfo?.rating }}</p>
                    <ig-stars [rating]="data.item.venueInfo?.rating"></ig-stars>
                </div>

                <div *ngIf="data.item.venueInfo?.reviews">{{ data.item.venueInfo?.reviews }} reviews</div>

                <div class="relative m-t-2">
                    <div *ngIf="data.item?.isOnlineEvent" class="online-event-tip">
                        (Online event)
                    </div>
                </div>

                <div *ngIf="data.item.address?.address" class="m-t-2">
                    <ig-button size="md" class="deep-orange-btn" (trigger)="getDirection()">Get directions</ig-button>
                    <!--            <ig-button size="md m-t-3" class="dark-blue-btn" (trigger)="close()">Back to all events</ig-button>-->
                </div>
            </div>

            <ig-upcoming-events [currentEvent]="data.item" [column]="1" (onMoreClick)="close()"
                                (onUpcomingEventClick)="close()"></ig-upcoming-events>

            <ig-button class="get-event-link" size="md" (trigger)="showEventLink()">Get Event Link</ig-button>

            <!--            <div class="event-host m-t-3">Event created by-->
            <!--                <a href="{{data.item?.hostLink}}" target="_blank">{{data.item?.owner.name}}</a>-->
            <!--            </div>-->

            <!--            <div class="flex">-->
            <!--                <mat-icon>date_range</mat-icon>-->
            <!--                <div>-->
            <!--                    <div class="event-time" *ngIf="!data.item.eventTimes||!data.item.eventTimes.length">-->
            <!--                        <span *ngIf="data.item.startTimeFormatted">{{data.item.startTimeFormatted}}{{data.item.endTimeFormatted ? ' - ' + data.item.endTimeFormatted : ''}}</span>-->
            <!--                    </div>-->
            <!--                    <div *ngIf="data.item.eventTimes && data.item.eventTimes.length">-->
            <!--                        <div class="event-time"-->
            <!--                             *ngFor="let timeRange of trancatedEventTimes">-->
            <!--                            {{timeRange.startTimeFormatted}} - {{timeRange.endTimeFormatted}}-->
            <!--                        </div>-->

            <!--                        <div *ngIf="data.item.eventTimes.length>3" class="times-more" (click)="showMoreTimes()">-->
            <!--                            {{trancatedEventTimes.length === 3 ? 'Show More' : 'Show Less'}}-->
            <!--                        </div>-->
            <!--                    </div>-->
            <!--                </div>-->
            <!--            </div>-->

            <!--            <ng-container *ngIf="data.item.address">-->
            <!--                <div class="flex">-->
            <!--                    <mat-icon>room</mat-icon>-->
            <!--                    <div class="event-time">-->
            <!--                        {{data.item['isOnlineEvent'] ? '(Online event)' : (data.item.address.address || data.item.address)}}-->
            <!--                    </div>-->
            <!--                </div>-->
            <!--            </ng-container>-->

        </ng-container>

        <div *ngIf="data.item['youtubeLink']||data.item['_360VideoKey']" class="m-b-2 m-t-4">
            <!--            <div class="text-2xl text-gray-600 font-bold mb-3">{{ videoTitle }}</div>-->
            <div class="flex gap-4 mobile:flex-col ig-trip-place-video">
                <div *ngIf="data.item['youtubeLink']"
                     class="full-width ig-trip-place-player">
                    <iframe vision *ngIf="data.item['youtubeLink']" width="100%" height="100%" [src]="getYoutubeLink()"
                            title="YouTube video player" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen></iframe>
                </div>
                <!--                <div *ngIf="data.item['_360VideoKey']"-->
                <!--                     class="full-width ig-trip-place-player">-->
                <!--                    <iframe [src]="get360VideoLink()" frameborder="0" allowfullscreen="1" width="100%" height="100%"-->
                <!--                            style="max-width:100%;"></iframe>-->
                <!--                </div>-->
            </div>
        </div>

        <div style="padding:0 24px"
             *ngIf="data.type==='place'&&((data.item.socialName==='google'&&googleInfo)||(data.item.socialName!=='google'))">

            <div class="place-info-wrap">
                <div style="flex:5" *ngIf="googleInfo?.opening_hours">
                    <ig-visitor-place-opening-hours [googlePlaceAdditionalData]="googleInfo" [hours]="data.item.hours"
                                                    [hoursText]="data.item.hoursText"></ig-visitor-place-opening-hours>
                </div>
                <div style="flex:4">
                    <div class="flex" *ngIf="data.item?.phone">
                        <mat-icon>phone</mat-icon>
                        <a [href]="getTel(data.item.phone)" class="text-left">{{ data.item.phone }}</a>
                    </div>

                    <div class="flex" *ngIf="data.item?.emails">
                        <mat-icon>email</mat-icon>
                        <div>{{ data.item?.emails }}</div>
                    </div>

                    <!--                    hide price for google place as Aline thinks it is too much-->
                    <div class="flex" *ngIf="data.item.socialName==='facebook'&&data.item?.priceRange">
                        <mat-icon>attach_money</mat-icon>
                        <div>{{ data.item?.priceRange }}</div>
                    </div>
                    <div class="text-left m-t-1" *ngIf="!!data.item.rating">
                        <p title>Rating {{ data.item.rating }}</p>
                        <ig-stars [rating]="data.item.rating"></ig-stars>
                    </div>
                </div>
            </div>

            <ng-container *ngIf="data.item['category']">
                <div class="flex" [class.m-t-2]="data.item.socialName==='google'">
                    <mat-icon>list</mat-icon>
                    <div class="event-time">
                        {{ data.item['category'] }}
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="data.item.address">
                <div class="flex" [class.m-t-2]="data.item.socialName==='google'&&!data.item['category']">
                    <mat-icon>room</mat-icon>
                    <div class="event-time">
                        {{ data.item.address.address || data.item.address }}
                    </div>
                </div>
            </ng-container>

            <div *ngIf="data.item['about']||data.item.description" class="detail-description">
                {{ data.item['about'] }}<br *ngIf="data.item['about']"/><br *ngIf="data.item['about']"/>
                <div #description [innerHTML]="data.item.description"></div>
            </div>

            <ig-button size="md" class="deep-orange-btn m-t-1 m-b-1" (trigger)="getDirection()">Get Directions
            </ig-button>
            <!--            <ig-button size="md" class="m-t-1 m-b-1" color="cancel" (trigger)="visitWebsite()">More info</ig-button>-->

        </div>

        <!--        <div description *ngIf="data.type==='event'" [innerHTML]="data.item.description||'(No Description)'"></div>-->

        <!--        <div group class="m-t-2" style="padding:0 24px">-->
        <!--            <ig-button *ngIf="!data.item['isOnlineEvent']" size="md" class="deep-orange-btn" (trigger)="getDirection()">Get Directions</ig-button>-->
        <!--            <ig-button *ngIf="data.item['ticketUri']" size="md" class="deep-orange-btn m-t-1" (trigger)="buyTicket()">Buy Ticket</ig-button>-->
        <!--            <ig-button *ngIf="data.item['eventLink']" size="md" class="m-t-1" (trigger)="visitWebsite()">{{isAccommodation?'Book Now':'More Information'}}</ig-button>-->
        <!--        </div>-->

    </div>

    <div class="detail-share" *ngIf="!userSelectedToViewFeed" style="padding:0px 18px 10px 24px">
        <ig-social-share [item]="data.item" appearance="rounded"></ig-social-share>
    </div>

    <div class="feed-wrap" *ngIf="userSelectedToViewFeed" style="position: relative;padding: 0 24px 24px">
        <ng-container *ngIf="isShowFacebookFeed">
            <div class="fb-post-title"
                 *ngIf="data.item.socialName==='facebook'||(placeFeeds&&placeFeeds.length&&data.item.socialName==='google')">
                <img [src]="facebookLogo" alt="">
                FACEBOOK POSTS
            </div>
            <ig-spinner *ngIf="!isFBFeedLoaded" style="top: 45%;left:45%;position: absolute"></ig-spinner>
            <div *ngIf="NoFeed&&data.item.socialName==='facebook'" class="no-item">No posts available</div>
            <ig-button *ngIf="NoFeed&&data.item.socialName==='facebook'"
                       style="position: absolute;width: 100%;bottom: 0;"
                       size="md"
                       (trigger)="back()">
                back to place details
            </ig-button>
            <ng-container *ngIf="isFBFeedLoaded&&!NoFeed">
                <div class="facebook-posts">
                    <ig-facebook-post *ngFor="let post of placeFeeds"
                                      [post]="post">
                    </ig-facebook-post>
                    <ig-button *ngIf="isFBFeedLoaded&&placeFeedPaging&&placeFeedPaging.next"
                               [isAsync]="true"
                               size="md"
                               (trigger)="getNextFacebookPlaceFeed($event)">
                        Load More
                    </ig-button>
                </div>
                <ig-button class="fb-btn" size="md" (trigger)="viewFBPage()">View Facebook Page</ig-button>
            </ng-container>
        </ng-container>

        <ng-container *ngIf="isShowNearbyPlaces">
            <ig-nearby-places [position]="'right'" [currentPlace]="data.item" [source]="placeSource"
                              (onGotoPlace)="gotoPlace($event)"
            ></ig-nearby-places>
        </ng-container>

        <ng-container *ngIf="isShowGoogleFeed&&featuresToggle.googleReviews">
            <div class="google-review-wrap"
                 [class.no-fb-post-google-review-wrap]="!placeFeeds||!placeFeeds.length">
                <ig-google-place-reviews [reviews]="googleInfo?.reviews||googleInfo?.googleReviews"
                                         [placeId]="data.item?.id"
                                         [googleLink]="googleInfo?.url||googleInfo?.hostLink"></ig-google-place-reviews>
            </div>
        </ng-container>

    </div>

</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/visitor/trip/trip.detail.modal/trip.detail.modal.component.html